import { browserFastApiClient } from "@/core/fastapi";
import {
  transcribePublicFeedbackApiService,
  type TranscribePublicFeedbackResult,
} from "@/generated/fastapi";

export async function transcribePublicFeedback(
  token: string,
  file: File,
): Promise<TranscribePublicFeedbackResult> {
  const response = await transcribePublicFeedbackApiService({
    client: browserFastApiClient,
    path: { token },
    body: { file: file as unknown as string },
  });

  if (response.status !== 200 || !response.data) {
    throw new Error(`Failed to transcribe feedback (${response.status})`);
  }

  if (response.data.status !== "success") {
    throw new Error(response.data.message || "Failed to transcribe feedback");
  }

  return response.data;
}
